import { logger } from '@price-pages-agency-cards/src/infrastructure/logger';
import { sendAnalyticsEvent } from '@shared-utils/helpers/tracking';
export const sendAnalytics = (event, parentId) => {
    sendAnalyticsEvent(event, logger.error, parentId);
};
